import { redirect } from "react-router-dom";
import { deleteSource } from "../../../data/money/sources";

export async function action({ params }) {
    await deleteSource(params.sourceId);
    return redirect("/");
}